import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;


//Fetch collectioin of events
export const fetchEvents = async () => {
  try {
    const response = await axios.get(`${apiUrl}/api/events`, {
        headers: {
            'ngrok-skip-browser-warning': 'true',
            'bypass-tunnel-reminder': 'true'
          },
      params: {
        populate: '*' // Populates all relations; adjust as needed
      }
    });
    console.log(response.data.data)
    return response.data.data; // Adjust based on Strapi's response structure
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};



// Fetch the single upcoming performance (Single Type)
export const fetchUpcomingPerformance = async () => {
    
    try {
      const response = await axios.get(`${apiUrl}/api/upcoming-performance`, {
        headers: {
            'ngrok-skip-browser-warning': 'true',
            'bypass-tunnel-reminder': 'true'
          },
        params: {
          populate: '*' // Populates all relations; adjust as needed
        }
      });
      console.log(response.data.data);
      return response.data.data; // Adjust based on Strapi's response structure
    } catch (error) {
      console.error('Error fetching upcoming performance:', error);
      throw error;
    }
  };



  // Fetch the single upcoming performance (Single Type)
export const fetchFooter = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/footer`, {
        headers: {
            'ngrok-skip-browser-warning': 'true',
            'bypass-tunnel-reminder': 'true'
          },
        params: {
          populate: '*' // Populates all relations; adjust as needed
        }
      });
      console.log(response.data.data);
      return response.data.data; // Adjust based on Strapi's response structure
    } catch (error) {
      console.error('Error fetching upcoming performance:', error);
      throw error;
    }
  };


    // Fetch the single upcoming performance (Single Type)
export const fetchHero = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/hero`, {
        headers: {
            'ngrok-skip-browser-warning': 'true',
            'bypass-tunnel-reminder': 'true'
          },
        params: {
          populate: '*' // Populates all relations; adjust as needed
        }
      });
      console.log(response.data.data);
      return response.data.data; // Adjust based on Strapi's response structure
    } catch (error) {
      console.error('Error fetching upcoming performance:', error);
      throw error;
    }
  };


      // Fetch the single upcoming performance (Single Type)
    export const fetchLocations = async () => {
        try {
        const response = await axios.get(`${apiUrl}/api/locations`, {
            headers: {
                'ngrok-skip-browser-warning': 'true',
            'bypass-tunnel-reminder': 'true'
              },
            params: {
            populate: '*' // Populates all relations; adjust as needed
            }
        });
        console.log(response.data.data);
        return response.data.data; // Adjust based on Strapi's response structure
        } catch (error) {
        console.error('Error fetching locations:', error);
        throw error;
        }
    };



  //Fetch list of media for partners
export const fetchPartners = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/partner`, {
        headers: {
            'ngrok-skip-browser-warning': 'true',
            'bypass-tunnel-reminder': 'true'
          },
        params: {
          populate: '*' 
        }
      });
      console.log(response.data.data)
      return response.data.data; 
    } catch (error) {
      console.error('Error fetching partners:', error);
      throw error;
    }
  };




    //Fetch list of artists
export const fetchArtists = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/artists`, {
        headers: {
            'ngrok-skip-browser-warning': 'true',
            'bypass-tunnel-reminder': 'true'
          },
        params: {
          populate: '*' 
        }
      });
      console.log(response.data.data)
      return response.data.data; 
    } catch (error) {
      console.error('Error fetching artists:', error);
      throw error;
    }
  };



    //Fetch about
export const fetchAbout = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/about`, {
        headers: {
            'ngrok-skip-browser-warning': 'true',
            'bypass-tunnel-reminder': 'true'
          },
        params: {
          populate: '*' 
        }
      });
      console.log(response.data.data)
      return response.data.data; 
    } catch (error) {
      console.error('Error fetching about:', error);
      throw error;
    }
  };


      //Fetch list of sounds
export const fetchSounds = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/sounds`, {
        headers: {
            'ngrok-skip-browser-warning': 'true',
            'bypass-tunnel-reminder': 'true'
          },
        params: {
          populate: '*' 
        }
      });
      console.log(response.data.data)
      return response.data.data; 
    } catch (error) {
      console.error('Error fetching audio:', error);
      throw error;
    }
  };



        //Fetch list of sounds
export const fetchRepertoire = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/repertoire`, {
        headers: {
            'ngrok-skip-browser-warning': 'true',
            'bypass-tunnel-reminder': 'true'
          },
        params: {
          populate: '*' 
        }
      });
      console.log(response.data.data)
      return response.data.data; 
    } catch (error) {
      console.error('Error fetching repertoire:', error);
      throw error;
    }
  };

export default axios;

